export default __webpack_public_path__ + "static/media/template28.33a984ef.svg";